import React from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { MdLogout } from "react-icons/md"
import useLogging from "../../hooks/useLogging"
const LogoutButton = () => {
	const { logout } = useAuth0()
	const logging = useLogging()

	const handleLogoutAuth0 = event => {
		event.preventDefault()
		event.stopPropagation()
		const returnToUrl = `${window.location.origin}/`
		logging.info("Logging out, redirecting to:", {
			returnToUrl: returnToUrl
		})
		logout({
			returnTo: returnToUrl
		})
	}

	return (
		<button
			onClick={handleLogoutAuth0}
			className="flex items-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
		>
			<MdLogout className="mr-2 text-lg text-white" />
			Log Out
		</button>
	)
}

export default LogoutButton
